import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { message, Modal } from 'antd';
import moment from 'moment';

//弹出mailmerge的div
export function docMergeInvoice({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mailMergeTemplateShow: true, mailMergeObjId: parameter.InvoiceId, dataModelType: 4 });
  setTimeout(() => {
    pageComponent.mailMergeTemplate.current?.getMailMergeTemplate(4);
  }, config.setTimeoutMilliSecond);
}

//通过 Status 更换icon
export function formatData({ parameter, sectionComponent, pageComponent } = {}) {
  let accountingAppInvoiceIds = [];
  parameter.map((item, i) => {
    setData(item, pageComponent);
    if (item.AccountingAppInvoiceId !== null) {
      accountingAppInvoiceIds.push(item.AccountingAppInvoiceId);
    }
  })

  calculateTotal(parameter, sectionComponent);

  //如果有绑定会计系统，开始查询相关数据
  if (pageComponent.state.jobData.ModuleConfig !== undefined && pageComponent.state.jobData.ModuleConfig.AccountingAppIntegrationId !== null) {
    getAccountingApp(pageComponent, accountingAppInvoiceIds);
  }
}

function setData(item, pageComponent) {
  //AccountingApp设置成空待查询
  item.AccountingApp = null;
  if (item.Status === 1) {
    item.StatusBackgroundColor = config.color.success;

    if (pageComponent.state.jobData.ModuleConfig !== undefined && pageComponent.state.jobData.ModuleConfig.AccountingAppIntegrationId !== null) {
      if (item.AccountingAppInvoiceId !== null && item.DueAmount !== null) {
        if (item.DueAmount > 0) {
          item.AccountingApp = globalFunction.formatMoney(item.DueAmount);
          item.AccountingAppBackgroundColor = config.color.danger;
        } else {
          // item.AccountingApp = 'Paid'.toUpperCase();
          // item.AccountingAppBackgroundColor = config.color.success;
        }
      }
    } else {
      if (item.Balance > 0) {
        item.Balance = globalFunction.formatMoney(item.Balance);
        item.BalanceBackgroundColor = config.color.danger;
      } else {
        item.Balance = 'Paid'.toUpperCase();
        item.BalanceBackgroundColor = config.color.success;
      }
    }

    if (item.Total < 0) {
      item.AccountingApp = 'Paid'.toUpperCase();
      item.AccountingAppBackgroundColor = config.color.success;
    }

  } else {
    item.StatusBackgroundColor = config.color.default;
    item.Balance = null;
  }
}

export function calculateTotal(parameter, sectionComponent) {
  let total = 0;
  let data = parameter.map((item, i) => {
    total += item.Total;
  })
  sectionComponent.props.parentComponent.setState({ tableFooter: 'Total: ' + globalFunction.formatMoney(total) });
}

export function getAccountingApp(pageComponent, accountingAppInvoiceIds) {
  let url = '/Business/Invoice/GetInvoicesDueAmount';
  if (pageComponent.props.accessCode !== undefined) {
    url = '/Business/Invoice/GetPublicInvoicesDueAmount?accessCode=' + pageComponent.props.accessCode;
  }
  httpClient
    .post(url, { appIntegrationId: pageComponent.state.jobData.ModuleConfig.AccountingAppIntegrationId, accountingAppInvoiceIds })
    .then(({ data }) => {
      if (data.data !== null) {
        let invoice = globalFunction.getSectionComponent(pageComponent, 'Invoice');
        if (invoice !== null) {
          // let replaceParameter = [];
          // replaceParameter.push({ targetKey: 'key', targetValue: 'AccountingApp', replaceKey: 'title', replaceValue: pageComponent.state.jobData.ModuleConfig.AccountingAppIntegration.TenantName });
          // globalFunction.replaceUie({ tableComponent: invoice.child.current, componentType: 'View', uieSource: 'AccountingApp', replaceParameter });

          invoice.child.current?.setState({ loaded: false });
          let newData = invoice.child.current?.state.data.map((invoiceItem, i) => {
            data.data.map((accountingItem, j) => {
              if (accountingItem.AccountingAppInvoiceId === invoiceItem.AccountingAppInvoiceId) {
                invoiceItem.AccountingApp = accountingItem.DueAmount;
                invoiceItem.ShowPayButton = false;
                switch (accountingItem.Status?.toLowerCase()) {
                  case 'paid':
                    //适应Xero
                    invoiceItem.AccountingApp = accountingItem.Status;
                    invoiceItem.AccountingAppBackgroundColor = config.color.success;
                    break;

                  case 'voided':
                  case 'deleted':
                    //同时适应Xero 和 Quickbooks
                    invoiceItem.AccountingApp = accountingItem.Status;
                    invoiceItem.AccountingAppBackgroundColor = config.color.inactive;
                    invoiceItem.ButtonFormat = [{ actionType: 'Delete', disabled: true }];
                    break;

                  default:
                    //同时适应Xero 和 Quickbooks
                    if (accountingItem.DueAmount > 0) {
                      invoiceItem.AccountingApp = globalFunction.formatMoney(accountingItem.DueAmount);
                      invoiceItem.AccountingAppBackgroundColor = config.color.danger;
                      if (!globalFunction.isNullOrEmpty(pageComponent.state.jobData.Company.MpgsDomain)) {
                        invoiceItem.ShowPayButton = true;
                      }
                    } else {
                      invoiceItem.AccountingApp = 'Paid';
                      invoiceItem.AccountingAppBackgroundColor = config.color.success;
                    }
                    break;
                }
              }
            })
            return invoiceItem;
          })
          invoice.child.current?.setState({ loaded: true });
          let sectionData = pageComponent.state.sectionData;
          sectionData['Invoice'] = newData;
          pageComponent.setState({ sectionData });
        }
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
